exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".pip-4ef44c24{display:inline-block;background-color:#757575;border-radius:50%;cursor:pointer;width:8px;height:8px;margin:5px}.pip-4ef44c24.active-bfa500ca{background-color:#BDBDBD}\n", ""]);

// Exports
exports.locals = {
	"pip": "pip-4ef44c24",
	"active": "active-bfa500ca"
};